import { css } from '@emotion/css';

export const footerFluid = css`
  width: 100%;
  background-color: #f6f8fb;
  padding: 60px 40px 20px 40px;
  color: #382110;
  margin-top: auto;
  border-top: 1px solid rgba(241, 102, 2, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const footerLogo = css`
  img {
    max-height: 45px;
    object-fit: contain;
    margin-bottom: 12px;
  }
`;

export const socialIcon = css`
  display: flex;
  margin-top: 15px;
  a {
    display: inline-block;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const footerFlex = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 992px) {
    flex-wrap: wrap;
    gap: 40px;
  }
`;

export const footerCols = css`
  h3 {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 800;
    color: #382110;
    margin: 0;
    margin-bottom: 30px;
    margin-top: 20px;
    letter-spacing: 0.05em;
    @media (max-width: 767px) {
      margin-bottom: 15px;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      list-style-type: none;
      a {
        display: block;
        margin-bottom: 10px;
        font-size: 14px;
        color: #594436;
        font-weight: 600;
        transition: all 0.2s ease;
        text-decoration: none;
        &:hover {
          color: #f16602;
          transform: translateX(4px);
        }
      }
    }
  }
`;

export const footerBox = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding-right: 60px;
  @media (max-width: 767px) {
    padding-right: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  p {
    font-size: 14px;
    margin-top: 0;
  }
  small {
    font-size: 12px;
    color: #594436;
    display: block;
    width: 100%;
    margin-left: 75px;
    margin-top: -13px;
    opacity: 0.8;
  }
`;

export const footerBoxFlex = css`
  display: flex;
  align-items: center;
`;

export const footerBoxImg = css`
  min-width: 60px;
  height: 60px;
  background: rgba(241, 102, 2, 0.08);
  border-radius: 5px;
  margin-right: 15px;
`;

export const colmd3 = css`
  flex: 0 0 30%;
  max-width: 30%;
  p {
    padding-right: 30px;
    font-size: 14px;
    color: #594436;
    font-weight: 600;
    margin-top: 15px;
    @media (max-width: 767px) {
      padding-right: 0;
    }
  }
  @media (max-width: 992px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const colmd2 = css`
  flex: 0 0 25%;
  max-width: 25%;
  @media (max-width: 992px) {
    flex: 0 0 45%;
    max-width: 45%;
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const colmd4 = css`
  flex: 0 0 35%;
  max-width: 35%;
  @media (max-width: 992px) {
    flex: 0 0 45%;
    max-width: 45%;
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const footerContact = css`
  li {
    list-style-type: none;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    color: #594436;
    font-weight: 600;
    font-size: 14px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      display: inline-block;
      margin-right: 12px;
    }
    a {
      color: #594436;
      text-decoration: none;
      transition: color 0.2s ease;
      &:hover {
        color: #f16602;
      }
    }
  }
`;

export const copyright = css`
  text-align: center;
  width: 100%;
  max-width: 1280px;
  font-size: 13px;
  padding-top: 30px;
  margin-top: 50px;
  border-top: 1px solid rgba(241, 102, 2, 0.08);
  color: #8c7665;
  font-weight: 500;
`;
